module.exports = __webpack_public_path__ + "assets/img/ban6.d038d749.png";